import React from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
const ScrollMarker = _ref => {
  let {
    position,
    visible = true
  } = _ref;
  const className = buildVersionedClassNames('ds-scroll-marker', {
    'ds-scroll-marker--left': position === 'left',
    'ds-scroll-marker--right': position === 'right',
    'ds-scroll-marker--top': position === 'top',
    'ds-scroll-marker--bottom': position === 'bottom'
  });
  if (visible) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    });
  }
  return null;
};
export default ScrollMarker;